"use client";

import { useEffect, useRef, useState } from "react";

interface UseIntersectionObserverOptions {
  rootMargin?: string;
  threshold?: number;
  enabled?: boolean;
}

export function useIntersectionObserver({
  rootMargin = "200px",
  threshold = 0,
  enabled = true
}: UseIntersectionObserverOptions = {}) {
  const ref = useRef<HTMLDivElement>(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (!enabled || !ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry) setIsIntersecting(entry.isIntersecting);
      },
      { rootMargin, threshold }
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [rootMargin, threshold, enabled]);

  return { ref, isIntersecting };
}
